/* eslint-disable */
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Calendar, Clock, MapPin, Tag, Edit2, Trash2 } from "lucide-react";
import { eventsApi } from "./api";
import { useAuth } from "../auth/AuthContext";
import { LocationPreview, venueLine } from "./location";
import "./EventDetail.css";

export default function EventDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isAdmin } = useAuth();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [toast, setToast] = useState("");

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 3000);
  };

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const data = await eventsApi.get(id);
      setEvent(data);
    } catch (e) {
      setError(e.message || "Could not load event");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const handleDelete = async () => {
    if (!window.confirm("Delete this event?")) return;
    setDeleting(true);
    try {
      await eventsApi.delete(id);
      navigate("/events");
    } catch (e) {
      showToast(e.message || "Could not delete event");
    } finally {
      setDeleting(false);
    }
  };

  if (loading) return <div className="evd-loading">Loading…</div>;
  if (error) return <div className="evd-error">{error}</div>;
  if (!event) return null;

  const venue = venueLine(event.location, event.venue);
  const dateObj = new Date(event.event_date + "T00:00:00");
  const formattedDate = dateObj.toLocaleDateString("en-IN", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="evd-page">
      {toast && <div className="evd-toast">{toast}</div>}
      <div className="evd-back-bar">
        <button className="evd-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Back
        </button>
        {isAdmin && (
          <div className="evd-admin-actions">
            <button
              className="evd-btn-edit"
              onClick={() => navigate(`/events/${id}/edit`)}
            >
              <Edit2 size={14} /> Edit
            </button>
            <button
              className="evd-btn-delete"
              onClick={handleDelete}
              disabled={deleting}
            >
              <Trash2 size={14} /> Delete
            </button>
          </div>
        )}
      </div>

      <div className="evd-card">
        {event.category && (
          <div className="evd-category">
            <Tag size={13} /> {event.category}
          </div>
        )}
        <h1 className="evd-title">{event.title}</h1>
        <div className="evd-meta-grid">
          <div className="evd-meta-item">
            <Calendar size={14} className="evd-icon" />
            <span>{formattedDate}</span>
          </div>
          {(event.start_time || event.end_time) && (
            <div className="evd-meta-item">
              <Clock size={14} className="evd-icon" />
              <span>
                {event.start_time ?? ""}
                {event.start_time && event.end_time ? " – " : ""}
                {event.end_time ?? ""}
              </span>
            </div>
          )}
          {venue && (
            <div className="evd-meta-item">
              <MapPin size={14} className="evd-icon" />
              <span>{venue}</span>
            </div>
          )}
        </div>
        <LocationPreview location={event.location} />
        {event.description && (
          <p className="evd-description">{event.description}</p>
        )}
        {event.created_by && (
          <p className="evd-footer">Posted by {event.created_by.name}</p>
        )}
      </div>
    </div>
  );
}
